import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ConsentPage } from './pages/authentication/consent/consent.page';
import { AuthGuard } from './guards/auth.guard';
import { HomePage } from './pages/authentication/home/home.page';
import { LoginPage } from './pages/authentication/login/login.page';
import { VerifyLoginPage } from './pages/authentication/verify-login/verify-login.page';
import { RegisterPage } from './pages/authentication/register/register.page';
import { VerifySignUpPage } from './pages/authentication/verify-sign-up/verify-sign-up.page';
import { ContactUsPage } from './pages/authentication/contact-us/contact-us.page';

const routes: Routes = [
  {
    path: 'unauthenticated',
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomePage },
      { path: 'login', component: LoginPage },
      { path: 'verifylogin', component: VerifyLoginPage },
      { path: 'register', component: RegisterPage },
      { path: 'consent', component: ConsentPage },
      { path: 'verifysignup', component: VerifySignUpPage },
      { path: 'contactus', component: ContactUsPage },
    ]
  },
  {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
